"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AppUploadField = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactAvatarEditor = _interopRequireDefault(require("react-avatar-editor"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _axios = _interopRequireDefault(require("axios"));

var _InputField = require("./InputField");

var _config = _interopRequireDefault(require("../../config"));

var _lodash = _interopRequireDefault(require("lodash"));

var _ProgressBarComponent = _interopRequireDefault(require("./ProgressBarComponent"));

var _reactRedux = require("react-redux");

var _AppValidationErrors = _interopRequireDefault(require("./AppValidationErrors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var STATUS_OLD = 'old';
var STATUS_NEW = 'new';
var STATUS_UPLOADING = 'uploading';
var STATUS_QUEUED = 'queued';
var STATUS_REMOVED = 'removed';

var extractName = function extractName(value) {
  return value.split('/').pop();
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    token: state.auth.token
  };
};

var AppUploadField = /*#__PURE__*/function (_React$Component) {
  _inherits(AppUploadField, _React$Component);

  function AppUploadField(props) {
    var _this;

    _classCallCheck(this, AppUploadField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppUploadField).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      files: []
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrop", function (acceptedFiles) {
      _this._addFiles(acceptedFiles);
    });

    if (props.value) {
      _this.state = {
        initialValue: null,
        files: [{
          id: _lodash["default"].uniqueId("prefix-"),
          file: props.value,
          name: extractName(props.value),
          path: _config["default"].publicUrl + props.value,
          status: STATUS_OLD,
          progress: 0,
          value: props.value
        }]
      };
    }

    return _this;
  }

  _createClass(AppUploadField, [{
    key: "onImageChange",
    value: function onImageChange(event) {
      var _this2 = this;

      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          _this2.setState({
            image: e.target.result
          });
        };

        reader.readAsDataURL(event.target.files[0]);
      }
    }
  }, {
    key: "_addFiles",
    value: function _addFiles(acceptedFiles) {
      var _this3 = this;

      var parsedFiles = [];
      acceptedFiles.forEach(function (file) {
        parsedFiles.push({
          id: _lodash["default"].uniqueId("prefix-"),
          file: file,
          name: file.name,
          path: file.preview,
          status: STATUS_QUEUED,
          progress: 0,
          value: null
        });
      });

      if (!this.props.multiple) {
        this.setState({
          files: [parsedFiles[0]]
        }, function () {
          return _this3._triggerUpload();
        });
      } else {
        this.setState({
          files: [].concat(_toConsumableArray(this.state.files), parsedFiles)
        }, function () {
          return _this3._triggerUpload();
        });
      }
    }
  }, {
    key: "_triggerUpload",
    value: function _triggerUpload() {
      var _this4 = this;

      this.state.files.forEach(function (file) {
        if (file.status == STATUS_QUEUED) {
          _this4._startUploading(file);
        }
      });
    }
  }, {
    key: "_startUploading",
    value: function () {
      var _startUploading2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
        var _this5 = this;

        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = new FormData();
                data.append('file', file.file);
                data.append('filename', file.name);

                this._updateFile(file, {
                  status: STATUS_UPLOADING
                });

                _axios["default"].post(_config["default"].url + 'tools/upload', data, {
                  headers: {
                    Authorization: 'Bearer ' + this.props.token
                  },
                  onUploadProgress: function onUploadProgress(progressEvent) {
                    var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);

                    _this5._updateFile(file, {
                      progress: percentCompleted
                    });
                  }
                }).then(function (response) {
                  if (response.data.success) {
                    _this5._updateFile(file, {
                      value: response.data.data.name,
                      path: _config["default"].publicUrl + response.data.data.preview,
                      status: STATUS_NEW
                    });
                  }
                })["catch"](function (error) {
                  _this5._removeFile(file);
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _startUploading(_x) {
        return _startUploading2.apply(this, arguments);
      }

      return _startUploading;
    }()
  }, {
    key: "_updateFile",
    value: function _updateFile(file, data) {
      var _this6 = this;

      var files = _toConsumableArray(this.state.files);

      var foundFile = files.find(function (x) {
        return x.id == file.id;
      });

      if (foundFile) {
        var index = files.indexOf(foundFile);

        var newFile = _objectSpread({}, foundFile, {}, data);

        files[index] = newFile;
        this.setState({
          files: files
        }, function () {
          return _this6._afterFilesUpdate();
        });
      }
    }
  }, {
    key: "_removeFile",
    value: function _removeFile(file) {
      var _this7 = this;

      var files = _toConsumableArray(this.state.files);

      var index = files.indexOf(file);

      if (index >= 0) {
        files.splice(index, 1);
        this.setState({
          files: files
        }, function () {
          _this7._afterFilesUpdate();
        });
      }
    }
  }, {
    key: "_afterFilesUpdate",
    value: function _afterFilesUpdate() {
      if (this.props.handler) {
        if (!this.props.multiple) {
          this.props.handler.handleInputChange(this.props.name, this.state.files[0] ? this.state.files[0].value : null);
        }
      }
    }
  }, {
    key: "_getDropzone",
    value: function _getDropzone() {
      var _this8 = this;

      if (!this.props.multiple && this.state.files.length > 0) return null;
      return _react["default"].createElement(_reactDropzone["default"], {
        accept: this.props.accept,
        onDrop: this.handleDrop,
        multiple: this.props.multiple,
        style: {
          display: 'inline-block',
          padding: 20,
          textAlign: 'center',
          border: '2px dashed #fff',
          borderRadius: 10
        }
      }, function (_ref) {
        var getRootProps = _ref.getRootProps,
            getInputProps = _ref.getInputProps;
        return _react["default"].createElement("div", getRootProps(), _react["default"].createElement("div", {
          style: {
            width: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative'
          },
          className: "uploadButton"
        }, _react["default"].createElement("button", {
          type: "file",
          value: "upload",
          className: "cancelBtn",
          style: {
            color: 'white',
            background: 'transparent',
            opacity: 0
          }
        }, " "), _react["default"].createElement("p", null, "BROWSE"), _react["default"].createElement("input", _extends({
          type: "file",
          id: "profile_pic",
          name: "profile_pic",
          title: " ",
          accept: _this8.props.accept,
          onChange: _this8.onImageChange.bind(_this8),
          style: {
            opacity: 0
          },
          className: "fileInput-addnewproject"
        }, getInputProps())), _react["default"].createElement("div", {
          style: {
            color: '#fff',
            marginTop: 20
          }
        }, _react["default"].createElement("div", null, _react["default"].createElement("em", {
          className: "fa fa-fw fa-upload",
          style: {
            fontSize: '4em'
          }
        })), _react["default"].createElement("div", null, _react["default"].createElement("span", null, "or")), _react["default"].createElement("div", null, _react["default"].createElement("span", null, "drag n' drop here")))));
      });
    }
  }, {
    key: "_getUploadedFiles",
    value: function _getUploadedFiles() {
      var _this9 = this;

      if (!this.state.files.length) return null;
      var elements = [];

      var UploadedFile = function UploadedFile(props) {
        return _this9._getUploadedFileItem(props.file);
      };

      this.state.files.forEach(function (file, index) {
        elements.push(_react["default"].createElement(UploadedFile, {
          file: file,
          key: index
        }));
      });
      return elements;
    }
  }, {
    key: "_getThumbnailPath",
    value: function _getThumbnailPath(path) {
      if (!path) return null;
      var parts = path.split('.');
      var filename = path.split('/').pop();
      var extension = parts[parts.length - 1];

      if (['jpg', 'jpeg', 'png'].filter(function (x) {
        return x == extension;
      }).length) {
        return path;
      }

      if (path.substring(0, 5) == 'http:' || path.substring(0, 6) == 'https:') {
        return path;
      }

      if (path[0] == '/') return _config["default"].publicUrl + path;
      return _config["default"].publicUrl + '/admin/api/tools/preview/' + filename;
    }
  }, {
    key: "_getUploadedFileItem",
    value: function _getUploadedFileItem(file) {
      var _this10 = this;

      var bottomElement = null;

      if (file.status == STATUS_UPLOADING) {
        bottomElement = _react["default"].createElement("div", {
          style: {
            marginTop: 10
          }
        }, _react["default"].createElement(_ProgressBarComponent["default"], {
          percentage: file.progress
        }));
      } else {
        bottomElement = _react["default"].createElement("div", {
          style: {
            marginTop: 10
          }
        }, _react["default"].createElement("a", {
          href: "javascript:void(0)",
          onClick: function onClick() {
            return _this10._removeFile(file);
          }
        }, "Remove"));
      }

      return _react["default"].createElement("div", {
        className: "file-preview",
        style: {
          display: 'inline-block',
          border: '1px solid #e0e0e0',
          padding: 10,
          textAlign: 'center'
        }
      }, _react["default"].createElement("p", null, file.name), _react["default"].createElement("div", {
        style: {
          width: 300,
          height: 200,
          backgroundPosition: 'center center',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundImage: 'url("' + this._getThumbnailPath(file.path) + '")'
        }
      }), bottomElement);
    }
  }, {
    key: "render",
    value: function render() {
      var dropzone = this._getDropzone();

      var uploadedFiles = this._getUploadedFiles();

      return _react["default"].createElement("div", {
        className: "app-upload-btn-holder"
      }, _react["default"].createElement("label", {
        style: {
          color: 'white'
        }
      }, this.props.label), _react["default"].createElement("div", null, dropzone, uploadedFiles), _react["default"].createElement(_AppValidationErrors["default"], {
        errors: this.props.handler.getErrors(),
        name: this.props.name
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var stateChange = {};

      if (props.value && !state.initialValue) {
        stateChange.initialValue = props.value;
        stateChange.files = [{
          id: _lodash["default"].uniqueId("prefix-"),
          file: props.value,
          name: extractName(props.value),
          path: props.value[0] == '/' ? _config["default"].publicUrl + props.value : '/admin/api/tools/preview/' + props.value,
          status: STATUS_OLD,
          progress: 0,
          value: props.value
        }];
      }

      return stateChange;
    }
  }]);

  return AppUploadField;
}(_react["default"].Component);

exports.AppUploadField = AppUploadField;

var _default = (0, _reactRedux.connect)(mapStateToProps)(AppUploadField);

exports["default"] = _default;
AppUploadField.defaultProps = {
  label: '*Upload the school cover image',
  accept: ".jpg, .jpeg, .png",
  multiple: false
};